<div class="wrapper">
  <!-- 關閉按鈕 全部wallet共用一顆 -->
  <cs-icon-button
    class="btn-close"
    iconType="icon"
    icon="fi-x"
    color="secondary"
    size="12"
    (buttonClick)="walletService.closeWallet()"
  ></cs-icon-button>
  @switch (this.walletService.walletDialogType$ | async) { @case(walletDialogType.FIRST_DEPOSIT){
  <first-deposit></first-deposit>
  } @case(walletDialogType.DEPOSIT_WITHDRAW){
  <deposit-withdraw></deposit-withdraw>
  } @case(walletDialogType.ADDRESS_QR){
  <address-qr></address-qr>
  } @case(walletDialogType.SAVED_ADDRESS){
  <saved-address></saved-address>
  } @case(walletDialogType.ADD_EDIT_ADDRESS){
  <add-edit-address></add-edit-address>
  } @case(walletDialogType.VERIFY_2FA){
  <verify-2fa [otpType]="walletService.otpType" [verifyFunc]="walletService.verify2fa.bind(walletService)"></verify-2fa>
  } @case(walletDialogType.DEPOSIT_TRANSACTION_DETAILS){
  <app-deposit-transaction-details></app-deposit-transaction-details>
  } @case(walletDialogType.WITHDRAW_TRANSACTION_DETAILS){
  <wallet-details></wallet-details>
  } @case(walletDialogType.CONFIRM_PAGE){
  <app-cs-confirm-popup
    [header]="walletService.confirmPageData?.header || ''"
    [type]="'error'"
    [title]="walletService.confirmPageData?.title || ''"
    [message]="walletService.confirmPageData?.message || ''"
    [color]="'accent'"
    [confirmText]="'Close'"
    (confirm)="walletService.closeWallet()"
  ></app-cs-confirm-popup>
  } @default {
  <div class="error-message">Unknown wallet dialog type</div>
  } }
</div>
